module.exports = __webpack_public_path__ + "img/icon336.bce1cd70.png";